import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialQuery?: string;
  compact?: boolean;
  autoFocus?: boolean;
}

export function SearchBar({ initialQuery = '', compact = false, autoFocus = false }: SearchBarProps) {
  const [query, setQuery] = useState(initialQuery);
  const navigate = useNavigate();

  useEffect(() => setQuery(initialQuery), [initialQuery]);

  function submitSearch(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const term = query.trim();
    if (term) navigate(`/busca?q=${encodeURIComponent(term)}`);
  }

  return (
    <form className={compact ? 'search-form compact-search' : 'search-form'} onSubmit={submitSearch} role="search">
      <label className="sr-only" htmlFor={compact ? 'header-search' : 'help-search'}>
        O que você quer aprender ou resolver?
      </label>
      <input
        id={compact ? 'header-search' : 'help-search'}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={compact ? 'Buscar ajuda' : 'O que você quer aprender ou resolver?'}
        autoFocus={autoFocus}
        type="search"
      />
      <button type="submit">Buscar</button>
    </form>
  );
}
